import React from 'react';
import { Handle, Position } from '@xyflow/react';


const ExecutionTraceNode = ({ data, selected }) => {
  const {
    id,
    title,
    status,
    statusLabel,
    summary,
    durationMs,
    traceNode,
    onSelect
  } = data;

  return (
    <button
      type="button"
      className={`execution-trace-node status-${status}`}
      data-trace-node-id={id}
      data-node-selected={selected ? 'true' : 'false'}
      onClick={() => onSelect(traceNode)}
    >
      <Handle type="target" position={Position.Left} />
      <span className="execution-trace-node-title">{title}</span>
      <span className="execution-trace-node-status">{statusLabel}</span>
      <span className="execution-trace-node-summary">{summary}</span>
      {durationMs != null && (
        <span className="execution-trace-node-duration">
          {durationMs} ms
        </span>
      )}
      <Handle type="source" position={Position.Right} />
    </button>
  );
};


export default ExecutionTraceNode;
